﻿/* global jQuery */
import { EventIds, ProcessStep } from './StartDesignerProcessSteps.js';
import { JQueryPopupDialog } from './JQueryPopupDialog.js';
import { BootstrapStatuses } from './DesignerAppLauncher.js';

class ProcessRuleBase {
  constructor() {
    this.process = null; // Must be assigned by owner
  }

  matches(event) {
    return false;
  }
}

export class ProcessRule extends ProcessRuleBase {
  constructor(eventId, stepRef, customPredicate) {
    super();
    this.eventId = eventId;
    this.customPredicate = customPredicate;
    if (typeof value === 'string') {
      this.step = this.process.steps[stepRef];
      if (!this.step) {
        throw Error(`Unable to find a process step with id = '${stepRef}'`);
      }
    } else if (stepRef instanceof ProcessStep) {
      this.step = stepRef;
    } else {
      throw Error(`The step reference is of a unsupported type (${stepRef})`);
    }
  }

  matches(event) {
    let matches = event.id === this.eventId;
    if (matches && this.customPredicate) {
      matches = this.customPredicate(this, event);
    }
    return matches;
  }
}

export class StartDesignerProcess {
  constructor(config) {
    this.steps = {};
    this.rules = [];
    this.config = config;
    config.dialogConfig.closeEventId = EventIds.dialogClosed;
    this.popupDialog = new JQueryPopupDialog(this, config.dialogConfig);
    this.isActive = false;
    this.currentStep = null;
  }

  addStep(stepId, step) {
    step.id = stepId;
    step.dispatcher = this;
    step.popupDialog = this.popupDialog;
    //if (!step.config) {
    //  step.config = {};
    //}
    //step.config.downloadButtonText = this.config.downloadButtonText
    this.steps[stepId] = step;
    return step;
  }

  addRule(eventId, stepRef, customPredicate) {
    const rule = new ProcessRule(eventId, stepRef, customPredicate);
    rule.process = this;
    this.rules.push(rule);
    return rule;
  }

  dispatch(event) {
    console.group(`Received event ${event.id}`);

    if (event.triggerStep && event.triggerStep.isStartStep) {
      this.currentStep = event.triggerStep;
      this.isActive = true;
      console.log(`Starting process, initiated by '${this.currentStep.id}' step...`);
    }

    let wasHandled = false;
    let executePromise = null;
    for (let rule of this.rules) {
      if (rule.matches(event)) {
        wasHandled = true;
        if (this.currentStep) {
          console.log(`'${this.currentStep.id}' step: calling done()...`);
          this.currentStep.done();
        }
        this.currentStep = rule.step;
        console.log(`'${rule.step.id}' step: executing...`);
        executePromise = rule.step.execute(event); // This is an async call!!!!
        console.log(`'${rule.step.id}' step: continuing without waiting...`);
        break;
      }
    }

    if (wasHandled) {
      if (this.currentStep.isStopStep) {
        executePromise.then(() => {
          this.currentStep.done();
          this.currentStep = null;
          this.isActive = false;
        });
      }
    } else {
      if (event.id === EventIds.bootstrapStatusChanged) {
        if (event.data.status === BootstrapStatuses.Downloaded) {
          console.log(`Event ${event.id} with status '${event.data.status}' was unhandled, but is one of the known situations we just ignore...`);
        } else {
          // TODO: Review whether it's correct to close the popup dialog (and stop the process) on this event
          console.log(`Event ${event.id} with status '${event.data.status}' was unhandled! Closing the popup dialog...`);
          this.popupDialog.close();
        }
      } else {
        // TODO: Review whether it's correct to close the popup dialog (and stop the process) on this event
        console.log(`Event ${event.id} was unhandled! Closing the popup dialog...`);
        this.popupDialog.close();
      }
    }
    console.groupEnd();
  }

  /**
   * The owner will notify us whenever a Bootstrap status change occurs.
   * @param {any} monitor The object responsible for monitoring status changes.
   */
  notifyBootstrapStatusChanged(monitor) {
    const event = {
      id: EventIds.bootstrapStatusChanged,
      data: {
        priorStatus: monitor.priorStatus,
        status: monitor.status
      }
    };
    this.dispatch(event);
  };

  /**
   * The owner will notify us whenever an error occurs during Bootstrap status monitoring.
   * @param {object} monitor The object responsible for monitoring status changes.
   * @param {any} error An error object, could be a string, or an Error instance.
   */
  notifyBootstrapStatusMonitorError(monitor, error) {
    this.dispatch({ id: EventIds.errorOccurred, data: error });
  }
}
